import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {

  public track(eventName: string, params: any = {}): void {

    if (typeof window.fbq !== 'function') {
      return;
    }

    window.fbq('track', eventName, params);
  }

  public trackCustom(eventName: string, params: any = {}): void {

    if (typeof window.fbq !== 'function') {
      return;
    }

    window.fbq('trackCustom', eventName, params);
  }

}